import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postCreateOfferingTransaction } from '@arrived/api_v2';
import { CreateOfferingTransactionRequest, OfferingTransaction } from '@arrived/models';

import { balanceKeyFn, offeringBalancesKeyFn } from '../accounts';
import { offeringKeyFn, offeringsKeyFn } from '../offerings';
import { UseMutationOptions } from '../queries.utils';
import {
  accountSharesAvailableKeyFn,
  offeringSharesAvailableKeyFn,
  userSharesAvailableKeyFn,
} from '../sharesAvailable';
import { accountTradesQueryKeyFn, tradeQueryKeyFn, userTradesQueryKeyFn } from './trades.keys';

export function usePostTradeMutation(
  options?: UseMutationOptions<OfferingTransaction, CreateOfferingTransactionRequest>
) {
  const queryClient = useQueryClient();

  return useMutation((createTradeRequest) => postCreateOfferingTransaction(createTradeRequest), {
    ...options,
    onSuccess: (data, variables, context) => {
      const { id: tradeId, accountId, offeringId, userId } = data;

      queryClient.setQueryData(tradeQueryKeyFn(tradeId), data);

      queryClient.invalidateQueries(accountSharesAvailableKeyFn(offeringId, accountId));
      queryClient.invalidateQueries(userSharesAvailableKeyFn(offeringId, userId));
      queryClient.invalidateQueries(offeringSharesAvailableKeyFn(offeringId));

      queryClient.invalidateQueries(userTradesQueryKeyFn(userId));
      queryClient.invalidateQueries(accountTradesQueryKeyFn(accountId));

      queryClient.invalidateQueries(balanceKeyFn(accountId));
      queryClient.invalidateQueries(offeringBalancesKeyFn(accountId));

      queryClient.invalidateQueries(offeringsKeyFn());
      queryClient.invalidateQueries(offeringKeyFn(offeringId));

      options?.onSuccess?.(data, variables, context);
    },
  });
}
